import { render, staticRenderFns } from "./kayton-aloitus-form.vue?vue&type=template&id=50d2aae8&"
import script from "./kayton-aloitus-form.vue?vue&type=script&lang=ts&"
export * from "./kayton-aloitus-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports